//import sanitiseString from "./utils/sanitiseString";

//make sure js run after WP_Geo ajax completes 
jQuery(document).on("geotwp_ajax_success", function (event, response) {
  animateCounters();
});

function sanitiseString(inputString) {
  if (inputString === undefined || inputString === null) {
    return { sanitizedValue: 0, symbols: "" };
  }

  // Extract numeric part and symbols
  const sanitizedValue = inputString.match(/[\d,\.]+/g); // Match digits, commas, and dots
  const symbols = inputString.replace(/[\d,\.]+/g, ""); // Remove numeric part to get symbols

  // If there's no numeric part found, return default values
  if (!sanitizedValue) {
    return { sanitizedValue: "0", symbols: "" };
  }

  // Join matched numeric parts (in case of multiple matches) and parse as float
  const numberString = sanitizedValue.join('');
  return { sanitizedValue: numberString, symbols };
}

function numberWithCommas(x) {
  const parts = x.toString().split(".");
  
  // Format the integer part with commas
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
  // Return formatted number without unnecessary decimals
  return parts.length > 1 ? parts.join(".") : parts[0]; // Join only if there's a decimal part
}

function animateCounters() {
  document.querySelectorAll(".key-figures__numerical-value").forEach((item) => {
    // Get the current value from item.textContent
    const { sanitizedValue, symbols } = sanitiseString(item.textContent);
    
    // Determine if the original number is an integer or a float
    const isInteger = sanitizedValue.indexOf('.') === -1;

    // Parse the target value as a float
    const targetValue = parseFloat(sanitizedValue.replace(/,/g, "")); // Remove commas for parsing

    // Check if targetValue is a valid number
    if (isNaN(targetValue)) {
      return; // Skip this item if the target value is invalid
    }

    let currentValue = 0;
    const duration = 2500; // Animation duration in milliseconds
    const increment = targetValue / (duration / 10); // Calculate increment based on duration

    const interval = setInterval(() => {
      if (currentValue < targetValue) {
        currentValue += increment;
        item.textContent = numberWithCommas(currentValue.toFixed(isInteger ? 0 : 1)) + symbols; // Append symbols after formatting
      } else {
        item.textContent = numberWithCommas(targetValue) + symbols; // Ensure it ends at the target value with symbols
        clearInterval(interval);
      }
    }, 10);
  });
}

